import React from 'react';
import { Clock } from 'lucide-react';

const KYCPendingSection = () => {
  return (
    <div className="kyc-center-block kyc-review-center">
      <div className="kyc-review-ring">
        <Clock size={36} />
      </div>

      <h3 className="kyc-review-title">Documents Under Review</h3>

      {/* Countdown removed */}

      <p className="kyc-review-note">
        You will be notified once your application is approved.
      </p>
    </div>
  );
};

export default KYCPendingSection;